import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Combines clsx and tailwind-merge for optimal class name handling
 * - clsx: Conditionally join classNames together
 * - twMerge: Merge Tailwind CSS classes without conflicts
 *
 * Usage:
 * cn('px-4 py-2', condition && 'bg-red-500', { 'font-bold': isActive })
 * cn('p-4', 'p-2') // => 'p-2' (twMerge resolves conflicts)
 */
export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export default cn;
